// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Filter names enum.
 */
export enum FilterNameEnum {
  Equals = 0,
  NotEquals = 1,
  Contains = 2,
  NotContains = 3,
  StartsWith = 4,
  EndsWith = 5,
  Greater = 6,
  GreaterEqual = 7,
  Less = 8,
  LessEqual = 9,
  IsNull = 10,
  IsNotNull = 11,
  Between = 12
}
